import axios from "axios";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";
import qs from "qs";
import {
    ApiCredential,
    ApiCredentialDTOSchema,
    ApiCredentialSchema,
    IApiStatus,
} from "../types/ApiCredential";

export const ApiCredentialTransport = {
    list: async (params?: object): Promise<ApiCredential[]> => {
        const { data } = await axios.get(
            `/api-credentials${params ? `?${qs.stringify(params)}` : ""}`
        );

        return data.map((current: any) => ApiCredentialSchema.cast(toCamelCase(current)));
    },

    save: async (object: ApiCredential, id: number | undefined | null): Promise<ApiCredential> => {
        const response = await axios.request({
            method: id ? "put" : "post",
            url: id ? `/api-credentials/${id}` : "/api-credentials",
            data: toSnakeCase(ApiCredentialDTOSchema.cast(object)),
        });

        return ApiCredentialSchema.cast(toCamelCase(response.data));
    },

    apiStatus: async (): Promise<IApiStatus> => {
        const { data } = await axios.get(`/api-credentials/status`);
        return data;
    },

    toggleActive: async (object: ApiCredential): Promise<void> => {
        const action = "toggleActive";
        await axios.patch<ApiCredential>(`/api-credentials/${object.id}/actions/${action}`);
    },
};
